import React from 'react'

const HomeChefMenuIpad = () => {
    return (
        <div>HomeChefMenuIpad</div>
    )
}

export default HomeChefMenuIpad